export const staircaseConfig = {
    gameSlug: 'divided-attention',
    category: 'air_attention',
    variable: 'duration_ms',
    startValue: 250,
    minValue: 17,
    maxValue: 500,
    stepSizesByPhase: [50, 25, 12, 6],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 28,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            eccentricity: '10deg',
            nPeripheralTargets: 1,
            label: 'Champ proche',
        };
    }
    if (level <= 20) {
        return {
            level,
            eccentricity: '20deg',
            nPeripheralTargets: 1,
            label: 'Champ élargi',
        };
    }
    if (level <= 30) {
        return {
            level,
            eccentricity: '30deg',
            nPeripheralTargets: 1,
            label: 'Champ étendu',
        };
    }
    if (level <= 40) {
        return {
            level,
            eccentricity: '30deg',
            nPeripheralTargets: 2,
            label: 'Multi-foyer',
        };
    }
    return {
        level,
        eccentricity: '30deg',
        nPeripheralTargets: 2,
        label: 'Champ élite',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** 8 positions périphériques (cardinales + diagonales), en degrés horaire depuis le haut. */
export const PERIPHERAL_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];
/** Rayon de la couronne stimulus (px), grossi avec eccentricity bucket. */
export const eccentricityRadiusPx = {
    '10deg': 90,
    '20deg': 130,
    '30deg': 160,
};
/** Durées non-staircase (fixation, mask, ITI). */
export const timing = {
    fixationMs: 500,
    maskMs: 200,
    itiMs: 700,
    /** Floor sécurité : si staircase descend en-dessous, on cap rendu à 17ms. */
    minRenderMs: 17,
};
/** Cibles centrales — 2 catégories formes (carré / triangle). */
export const CENTRAL_CHOICES = ['square', 'triangle'];
export const CENTRAL_LABELS = {
    square: '■',
    triangle: '▲',
};
export const paradigmMeta = {
    slug: 'divided-attention',
    paradigm: 'UFOV-2 (Useful Field Of View, sub-test 2)',
    /** Internal only — never displayed; voice constraints forbid surfacing. */
    masterMage: 'Inori · Embra',
    category: 'air_attention',
    goal: "Surveille le centre et la périphérie en même temps. Identifie la forme centrale, puis pointe l'azimut où le point a flashé.",
};
//# sourceMappingURL=params.js.map